import { sessionState } from 'src/app/core/services/signal-state.storage';
import {
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StatusDTO } from 'src/app/gdo/gdo-shared/Models/Models';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import {
  cc_id,
  transformIntoApiCallObj,
} from 'src/app/gdo/gdo-shared/Models/Constants';
import { PaymentMethodInfo } from 'src/app/gdo/gdo-shared/Models/Interfaces';
import { GdoStepCompletionStatusComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';
import { GdoRemoveCardConfirmationDialogComponent } from '../gdo-remove-card-confirmation-dialog/gdo-remove-card-confirmation-dialog.component';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-gdo-payment-card',
    templateUrl: './gdo-payment-card.component.html',
    styleUrls: ['./gdo-payment-card.component.scss'],
    standalone: false
})
export class GdoPaymentCardComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Input() paymentCard!: PaymentMethodInfo;
  @Input() i: any;
  @Input() defaultPaymentMethodNo: any;
  @Input() paymentOptions!: PaymentMethodInfo[];
  @Output() cardDelete: EventEmitter<PaymentMethodInfo> = new EventEmitter();
  @Output() cardDefault: EventEmitter<PaymentMethodInfo> = new EventEmitter();
  @Output() setDefaultPaymentMethodEvent: EventEmitter<any> = new EventEmitter();
  isDefaultCard: boolean = false;
  isWebView: boolean = false;
  isAcura: boolean = false;

  constructor(
    private dialog: MatDialog,
    private appService: AppService,
    private router: Router
  ) { }

  ngOnInit(): void {
    if (this.appService.getWebviewCurrentStatus()) {
      this.isWebView = true;
    } else {
      this.isWebView = false;
    }
    this.setIsAcuraLocally();

    
    
    
    // 
  }

  setIsAcuraLocally() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
  }

  onClickSetDefault(card: PaymentMethodInfo) {
    // 
    // 
    this.cardDefault.emit(card)
  }

  onRemoveAndSetDefault(card: PaymentMethodInfo) {
    this.cardDefault.emit(card)
  }

  callFunc() {
    this.setDefaultPaymentMethodEvent.emit(this.defaultPaymentMethodNo);
  }

  onClickRemove(card: PaymentMethodInfo) {
    let dialogRef;

    if (
      card.payment_method_no !== this.defaultPaymentMethodNo ||
      this.paymentOptions.length === 1
    ) {
      if (this.isWebView) {
        dialogRef = this.dialog.open(GdoRemoveCardConfirmationDialogComponent, {
          data: card,
          panelClass: 'custom-modalbox-non-default-webview',
        });
      } else {
        dialogRef = this.dialog.open(GdoRemoveCardConfirmationDialogComponent, {
          data: card,
          panelClass: 'custom-modalbox-non-default-desktop',
        });
      }

      dialogRef.componentInstance.onRemove.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
        // do something
        this.cardDelete.emit(card);
      });

      dialogRef.afterClosed().pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(() => { });
    } else {
      let paymentOptions = this.paymentOptions.filter(
        (item) => item.payment_method_no !== this.defaultPaymentMethodNo
      );

      if (this.isWebView) {
        dialogRef = this.dialog.open(GdoRemoveCardConfirmationDialogComponent, {
          data: {
            card: card,
            paymentOptions: paymentOptions,
            defaultPaymentMethodNo: this.defaultPaymentMethodNo,
          },
          panelClass: 'custom-modalbox-default-webview',
        });
      } else {
        dialogRef = this.dialog.open(GdoRemoveCardConfirmationDialogComponent, {
          data: {
            card: card,
            paymentOptions: paymentOptions,
            defaultPaymentMethodNo: this.defaultPaymentMethodNo,
          },
          panelClass: 'custom-modalbox-default-desktop',
        });
      }

      dialogRef.componentInstance.onRemove.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
        // do something
        this.cardDelete.emit(card);
      });

      dialogRef.afterClosed().pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe((result) => {
        this.onRemoveAndSetDefault(result.event)
      });
    }
  }
}
